module.exports = __webpack_public_path__ + "static/Echa-7d73b1179c5e2fa2df93224f07694428.jpg";